import { render, staticRenderFns } from "./qs3-06.vue?vue&type=template&id=1d65e848&scoped=true&"
import script from "./qs3-06.vue?vue&type=script&lang=js&"
export * from "./qs3-06.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d65e848",
  null
  
)

export default component.exports